import React, { useMemo } from 'react';
import { Box, costFormater, Inscription, WarningLabel } from '@common-fe/common-fe';

enum EoyType {
  SHORTAGE = 'Shortage',
  SURPLUS = 'Surplus',
}

interface Props {
  visible?: boolean;
  amount?: number;
  planName?: string;
}

export const EoyReconReturnPlaceholder: React.FC<Props> = ({
  visible,
  amount,
  planName,
}) => {
  const surplusOrShortage = useMemo(() => {
    if (amount && amount > 0) return EoyType.SURPLUS;
    return EoyType.SHORTAGE;
  }, [amount]);

  const message = useMemo(() => {
    const formattedAmount = <Inscription weight="bold">{costFormater(Math.abs(amount || 0), { isOptionalPrecision: true })}</Inscription>;

    if (surplusOrShortage === EoyType.SURPLUS) {
      return (
        <Inscription
          data-testid="EoyReconReturnPlaceholder_confirm_message_surplus"
          color="textBody"
          size="medium"
        >
          End of year reconciliation of {planName} has been completed resulting in a surplus of {formattedAmount}. These funds will be returned as configured within the plan.
        </Inscription>
      );
    }

    return (
      <Inscription
        data-testid="EoyReconReturnPlaceholder_confirm_message_shortage"
        color="textBody"
        size="medium"
      >
        End of year reconciliation of {planName} has been completed resulting in a shortage of funds. {formattedAmount} is required to make the account whole.
      </Inscription>
    );
  }, [planName, amount, surplusOrShortage]);

  if (!visible || !amount) {
    return null;
  }

  return (
      <Box
        margin="-1px"
        pad={{ vertical: 'spacing16', horizontal: 'spacing24' }}
        background={{ color: 'warningContainer' }}
        border={{ size: '1px', color: 'warningBorder' }}
        round="fieldRound"
      >
        <Inscription weight="bold" margin={{ bottom: 'spacing8' }} color="textBody">
          <WarningLabel>
            {surplusOrShortage}
          </WarningLabel>
        </Inscription>

        <Box>
          {message}
        </Box>
      </Box>
  );
};
